module.exports = __webpack_public_path__ + "static/assets/d63a5fba92492bab99136021a79d43a3.png";